/**
 * CryptoRace Theme — arcade-style rainbow racetrack palette
 */

const font = {
  url: 'https://fonts.googleapis.com/css2?family=Fredoka:wght@400;500;600;700&display=swap',
  family: "'Fredoka', 'Comic Sans MS', system-ui, sans-serif",
};

export const theme = {
  colors: {
    background: '270 60% 4%',
    foreground: '0 0% 100%',
    card: '270 50% 10%',
    'card-foreground': '0 0% 100%',
    popover: '270 50% 10%',
    'popover-foreground': '0 0% 100%',
    primary: '326 100% 61%',
    'primary-foreground': '0 0% 100%',
    secondary: '270 40% 18%',
    'secondary-foreground': '0 0% 100%',
    muted: '270 40% 15%',
    'muted-foreground': '270 30% 65%',
    accent: '43 96% 56%',
    'accent-foreground': '270 60% 4%',
    destructive: '0 72% 51%',
    'destructive-foreground': '0 0% 100%',
    border: '270 40% 22%',
    input: '270 40% 18%',
    ring: '326 100% 61%',
    link: '270 70% 70%',
    'link-hover': '270 70% 80%',
    button: '326 100% 61%',
    'button-foreground': '0 0% 100%',
    'button-border': '326 100% 71%',
    'button-hover': '326 100% 51%',
    'button-hover-foreground': '0 0% 100%',
    'button-hover-border': '326 100% 61%',
    'button-ring': '326 100% 61%',
    'chart-1': '326 100% 61%',
    'chart-2': '43 96% 56%',
    'chart-3': '142 70% 45%',
    'chart-4': '200 100% 60%',
    'chart-5': '270 100% 70%',
    'sidebar-background': '270 60% 6%',
    'sidebar-foreground': '0 0% 85%',
    'sidebar-primary': '326 100% 61%',
    'sidebar-primary-foreground': '0 0% 100%',
    'sidebar-accent': '270 40% 15%',
    'sidebar-accent-foreground': '0 0% 85%',
    'sidebar-border': '270 40% 20%',
    'sidebar-ring': '326 100% 61%',
  },
  font,
  radius: '1.5rem',
};
